import { useMemo } from 'react';

import lookup from 'country-code-lookup';
import { DateTime } from 'luxon';
import { useRouter } from 'next/router';
import { Col, Row } from 'react-bootstrap';
import { Configure, InstantSearch, connectHits } from 'react-instantsearch-dom';


import { AlgoliaSearchClient } from '../../search/AlgoliaSearchClient';
import { TripAlgoliaHit } from '../../search/TripSearchResult';
import Swiper from '@website/components/directoryTheme/Swiper';

type RelatedTripsInnerProps = {
  hits: TripAlgoliaHit[];
};

export function ListRelatedTrips({ hits: trips }: RelatedTripsInnerProps) {
  const { query } = useRouter();

  const slug = query.tripUrl;

  // If there are no related trips, don't show anything
  if (trips.filter((trip) => trip.trip.urlSlug !== slug).length === 0) {
    return null;
  }

  return (
    <>
      <Row>
        <Col md="8">
          <h5 className="mb-0">Related Trips</h5>
        </Col>
      </Row>
      <Swiper
        className="guides-slider mx-n2 pt-3 pb-5"
        data={trips.filter((trip) => trip.trip.urlSlug !== slug).slice(0, 5)}
      />
    </>
  );
}

export const ShowRelatedTrips = connectHits(ListRelatedTrips);

type Props = {
  countryCode: string;
  activities?: string[];
};

export function RelatedTrips({ countryCode }: Props) {
  const region = useMemo(
    () => lookup.byIso(countryCode)?.region,
    [countryCode],
  );

  const startOfCurrentHour = DateTime.utc().startOf('hour').toMillis() / 1000;

  return (
    <InstantSearch searchClient={AlgoliaSearchClient} indexName="trips">
      <Configure
        filters={`region:"${region}" AND trip.active:"ACTIVE" AND private:false AND startTimestamp>${startOfCurrentHour}`}
        facetingAfterDistinct
        hitsPerPage={6}
      />
      <ShowRelatedTrips />
    </InstantSearch>
  );
}
